module.exports = __webpack_public_path__ + "img/175.47ec43c5.jpg";